function rvInitReveal() {
  var els = document.querySelectorAll('.rv-reveal:not(.rv-visible)');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('rv-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rv-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  els.forEach(function (el, i) {
    var group = el.closest('[data-rv-stagger]');
    var delay = group ? Math.min(i * 80, 320) : 0;
    el.style.setProperty('--rv-delay', delay + 'ms');
    observer.observe(el);
  });

  setTimeout(function () {
    document.querySelectorAll('.rv-reveal:not(.rv-visible)').forEach(function (el) {
      el.classList.add('rv-visible');
    });
  }, 2500);
}

function rvInitGaleria() {
  document.querySelectorAll('[data-rv-galeria]').forEach(function (grupo) {
    if (grupo.getAttribute('data-rv-galeria-ready')) return;
    grupo.setAttribute('data-rv-galeria-ready', '1');
    var id = grupo.getAttribute('data-rv-galeria');
    var principal = document.getElementById('rv-imagen-principal-' + id);
    if (!principal) return;
    grupo.querySelectorAll('.rv-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        principal.setAttribute('src', btn.getAttribute('data-full'));
        principal.setAttribute('alt', btn.getAttribute('data-alt') || '');
        grupo.querySelectorAll('.rv-thumb').forEach(function (b) { b.classList.remove('rv-thumb--active'); });
        btn.classList.add('rv-thumb--active');
      });
    });
  });
}

function rvInitVariantes() {
  document.querySelectorAll('[data-rv-opciones]').forEach(function (grupo) {
    if (grupo.getAttribute('data-rv-opciones-ready')) return;
    grupo.setAttribute('data-rv-opciones-ready', '1');
    var id = grupo.getAttribute('data-rv-opciones');
    var script = document.getElementById('rv-variantes-' + id);
    if (!script) return;
    var variantes;
    try { variantes = JSON.parse(script.textContent); } catch (e) { return; }

    var inputId = document.getElementById('rv-variant-id-' + id);
    var precioWrap = document.getElementById('rv-precio-' + id);
    var boton = document.getElementById('rv-boton-comprar-' + id);
    var botonTexto = document.getElementById('rv-boton-texto-' + id);
    var buyNowBtn = document.querySelector('[data-rv-buy-now="' + id + '"]');
    var opcionGrupos = grupo.querySelectorAll('.rv-opcion');
    var seleccion = [];
    opcionGrupos.forEach(function (og) {
      var activo = og.querySelector('.rv-opcion__valor--activo');
      seleccion.push(activo ? activo.getAttribute('data-valor') : null);
    });

    function moneyFmt(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function actualizar() {
      var match = variantes.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      })[0];
      if (!match) return;
      if (inputId) inputId.value = match.id;
      if (precioWrap) {
        var html = '<span class="rv-price-now">' + moneyFmt(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<span class="rv-price-was">' + moneyFmt(match.compare_at_price) + '</span>';
        }
        precioWrap.innerHTML = html;
      }
      if (boton) {
        boton.disabled = !match.available;
        if (botonTexto) {
          botonTexto.textContent = match.available
            ? botonTexto.getAttribute('data-disponible') || botonTexto.textContent
            : botonTexto.getAttribute('data-agotado') || 'Sold out';
        }
      }
      if (buyNowBtn) buyNowBtn.disabled = !match.available;
    }

    grupo.querySelectorAll('.rv-opcion__valor').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-opcion-index'), 10);
        var padre = btn.closest('.rv-opcion__valores');
        padre.querySelectorAll('.rv-opcion__valor').forEach(function (b) { b.classList.remove('rv-opcion__valor--activo'); });
        btn.classList.add('rv-opcion__valor--activo');
        seleccion[idx] = btn.getAttribute('data-valor');
        actualizar();
      });
    });
  });
}

function rvInitBaSlider() {
  document.querySelectorAll('[data-rv-baslider]').forEach(function (root) {
    if (root.getAttribute('data-rv-baslider-ready')) return;
    root.setAttribute('data-rv-baslider-ready', '1');

    var frame = root.querySelector('.rv-baslider__frame');
    var beforeImg = root.querySelector('.rv-baslider__img--before');
    var handle = root.querySelector('[data-rv-baslider-handle]');
    if (!frame || !beforeImg || !handle) return;

    var dragging = false;

    function setPct(pct) {
      pct = Math.min(Math.max(pct, 0), 100);
      beforeImg.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }

    function setFromClientX(clientX) {
      var rect = frame.getBoundingClientRect();
      var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
      setPct((x / rect.width) * 100);
    }

    frame.addEventListener('mousedown', function (e) {
      dragging = true;
      setFromClientX(e.clientX);
    });
    window.addEventListener('mousemove', function (e) {
      if (dragging) setFromClientX(e.clientX);
    });
    window.addEventListener('mouseup', function () { dragging = false; });

    frame.addEventListener('touchstart', function (e) {
      dragging = true;
      setFromClientX(e.touches[0].clientX);
    }, { passive: true });
    frame.addEventListener('touchmove', function (e) {
      if (dragging) setFromClientX(e.touches[0].clientX);
    }, { passive: true });
    frame.addEventListener('touchend', function () { dragging = false; });

    // Gentle auto-demo sweep the first time it scrolls into view, so it
    // reads as an interactive/alive element rather than two static photos.
    var demoed = false;
    function runDemo() {
      var start = null;
      var duration = 2200;
      function step(ts) {
        if (start === null) start = ts;
        var t = (ts - start) / duration;
        if (t >= 1) { setPct(50); return; }
        var eased = Math.sin(t * Math.PI);
        setPct(50 - eased * 24);
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    setPct(50);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !demoed) {
          demoed = true;
          runDemo();
          observer.unobserve(frame);
        }
      });
    }, { threshold: 0.5 });
    observer.observe(frame);
  });
}

function rvInitReviewsCarousel() {
  document.querySelectorAll('[data-rv-reviews-track]').forEach(function (track) {
    var id = track.getAttribute('data-rv-reviews-track');
    var prev = document.querySelector('[data-rv-reviews-prev="' + id + '"]');
    var next = document.querySelector('[data-rv-reviews-next="' + id + '"]');
    function step() {
      var card = track.querySelector('.rv-review--card');
      var gap = 28;
      return card ? card.getBoundingClientRect().width + gap : 340;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
}

function rvInitAccordion() {
  document.querySelectorAll('.rv-accordion').forEach(function (acc) {
    var items = acc.querySelectorAll('.rv-accordion__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  });
}

function rvInitQty() {
  document.querySelectorAll('[data-rv-qty]').forEach(function (wrap) {
    if (wrap.getAttribute('data-rv-qty-ready')) return;
    wrap.setAttribute('data-rv-qty-ready', '1');
    var id = wrap.getAttribute('data-rv-qty');
    var input = document.getElementById('rv-qty-' + id);
    var minus = wrap.querySelector('[data-rv-qty-minus]');
    var plus = wrap.querySelector('[data-rv-qty-plus]');
    if (!input) return;
    function clamp() {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      input.value = v;
    }
    if (minus) minus.addEventListener('click', function () {
      clamp();
      input.value = parseInt(input.value, 10) - 1;
      clamp();
    });
    if (plus) plus.addEventListener('click', function () {
      clamp();
      input.value = parseInt(input.value, 10) + 1;
      clamp();
    });
    input.addEventListener('change', clamp);
  });
}

function rvInitBuyNow() {
  document.querySelectorAll('[data-rv-buy-now]').forEach(function (btn) {
    if (btn.getAttribute('data-rv-buy-now-ready')) return;
    btn.setAttribute('data-rv-buy-now-ready', '1');
    var id = btn.getAttribute('data-rv-buy-now');
    btn.addEventListener('click', function () {
      var variantInput = document.getElementById('rv-variant-id-' + id);
      var qtyInput = document.getElementById('rv-qty-' + id);
      var variantId = variantInput ? variantInput.value : null;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!variantId) return;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add to cart failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
          window.location.href = '/cart';
        });
    });
  });
}

// Shopify renders a handful of platform-level strings (collection filters,
// sort options, policy link titles, the "powered by" footer line, and the
// virtual /collections/all heading) using its own locale catalog rather than
// the theme's locale JSON, so they follow the visitor's browser language
// instead of our theme translations. This forces those specific known
// strings to English regardless of visitor locale, so the storefront never
// shows a mixed English/Spanish page.
var RV_ES_EN_MAP = {
  'Productos': 'Products',
  'Disponibilidad': 'Availability',
  'Precio': 'Price',
  'Destacados': 'Featured',
  'Más relevantes': 'Most relevant',
  'Más relevante': 'Most relevant',
  'Relevancia': 'Most relevant',
  'Los más vendidos': 'Best selling',
  'Más vendidos': 'Best selling',
  'Alfabéticamente, A-Z': 'Alphabetically, A-Z',
  'Alfabéticamente, Z-A': 'Alphabetically, Z-A',
  'Precio, de menor a mayor': 'Price, low to high',
  'Precio, de mayor a menor': 'Price, high to low',
  'Fecha, de antiguo a nuevo': 'Date, old to new',
  'Fecha, de nuevo a antiguo': 'Date, new to old',
  'Política de privacidad': 'Privacy policy',
  'Términos del servicio': 'Terms of service',
  'Política de envío': 'Shipping policy',
  'Envío': 'Shipping policy',
  'Información de contacto': 'Contact information',
  'Contacto': 'Contact information',
  'Aviso legal': 'Legal notice'
};

var RV_ES_EN_SUBSTRINGS = [
  ['Tecnología de Shopify', 'Powered by Shopify'],
  ['tecnología de Shopify', 'Powered by Shopify'],
  ['Funciona con Shopify', 'Powered by Shopify'],
  ['Con la tecnología de Shopify', 'Powered by Shopify']
];

function rvSwapExactText(el) {
  var text = el.textContent.trim();
  if (RV_ES_EN_MAP.hasOwnProperty(text)) {
    if (el.textContent !== RV_ES_EN_MAP[text]) el.textContent = RV_ES_EN_MAP[text];
    return true;
  }
  return false;
}

function rvSwapTextNodesInScope(root) {
  if (!root || !document.createTreeWalker) return;
  var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
  var node;
  while ((node = walker.nextNode())) {
    var text = node.textContent.trim();
    if (text && RV_ES_EN_MAP.hasOwnProperty(text) && node.textContent !== RV_ES_EN_MAP[text]) {
      node.textContent = RV_ES_EN_MAP[text];
    }
  }
}

function rvInitEnglishPlatformStrings() {
  // Collection heading (e.g. the virtual /collections/all "Productos" title)
  document.querySelectorAll('.collection-hero__title').forEach(function (el) {
    rvSwapTextNodesInScope(el);
  });

  // Facet filter group labels ("Disponibilidad" / "Precio"). Dawn nests the
  // label text differently per filter type (plain text node for boolean
  // filters, span-in-div for range filters), so walk every text node inside
  // the summary instead of assuming a fixed structure.
  document.querySelectorAll('.facets__summary, .mobile-facets__summary').forEach(function (summary) {
    rvSwapTextNodesInScope(summary);
  });

  // Sort dropdown options
  document.querySelectorAll('select option').forEach(function (opt) {
    rvSwapExactText(opt);
  });

  // Footer policy links
  document.querySelectorAll('.policies a, .footer a').forEach(function (a) {
    rvSwapExactText(a);
  });

  // "Powered by Shopify" line and any other footer copyright text nodes
  document.querySelectorAll('.footer__copyright, .copyright__content').forEach(function (el) {
    Array.prototype.forEach.call(el.childNodes, function (node) {
      if (node.nodeType !== 3) return;
      var val = node.textContent;
      RV_ES_EN_SUBSTRINGS.forEach(function (pair) {
        if (val.indexOf(pair[0]) !== -1) val = val.split(pair[0]).join(pair[1]);
      });
      if (val !== node.textContent) node.textContent = val;
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  rvInitReveal();
  rvInitGaleria();
  rvInitVariantes();
  rvInitBaSlider();
  rvInitReviewsCarousel();
  rvInitAccordion();
  rvInitQty();
  rvInitBuyNow();
  rvInitEnglishPlatformStrings();

  var rvFacetsRoot = document.querySelector('.facets-container') || document.querySelector('#FacetFiltersForm');
  if (rvFacetsRoot && window.MutationObserver) {
    var rvFacetsObserver = new MutationObserver(function () {
      rvInitEnglishPlatformStrings();
    });
    rvFacetsObserver.observe(rvFacetsRoot, { childList: true, subtree: true });
  }
});

document.addEventListener('shopify:section:load', function () {
  rvInitReveal();
  rvInitGaleria();
  rvInitVariantes();
  rvInitBaSlider();
  rvInitReviewsCarousel();
  rvInitAccordion();
  rvInitQty();
  rvInitBuyNow();
  rvInitEnglishPlatformStrings();
});
